import { useEffect, useRef, useState } from 'react'
import { api, ApiError } from '../lib/api'

/** CHANGE MY PASSWORD (10 Oct 2026): from the menu on his own name, top
 *  right. The current password first, so somebody passing an open screen
 *  cannot; twelve characters or more, as Settings, Users asks; the new one
 *  twice. His other screens are signed out by the server; this one stays.
 *  Classes carry `cp-`. */

const MIN = 12

export function ChangePassword({ onClose }: { onClose: () => void }) {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [again, setAgain] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [done, setDone] = useState(false)
  const first = useRef<HTMLInputElement>(null)
  useEffect(() => { first.current?.focus() }, [])
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && !busy) onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [busy, onClose])

  const why = !current ? 'Type your current password.'
    : next.length < MIN ? `The new password is ${MIN} characters or more.`
    : next !== again ? 'The two new passwords are not the same.'
    : null

  async function save() {
    if (why || busy) return
    setBusy(true)
    setError(null)
    try {
      await api.changePassword(current, next)
      setDone(true)
      setCurrent(''); setNext(''); setAgain('')
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'It was not changed. Try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="modalback">
      <div className="modal cp-modal" role="dialog" aria-modal="true" aria-labelledby="cp-h">
        <h2 id="cp-h">Change my password</h2>
        {done ? (
          <>
            <p className="cp-ok">Changed. Your other signed-in screens were signed out; this one stays.</p>
            <div className="cp-foot"><button type="button" className="btn primary" onClick={onClose}>Done</button></div>
          </>
        ) : (
          <form onSubmit={(e) => { e.preventDefault(); save() }}>
            <label className="cp-field">Current password
              <input ref={first} type="password" autoComplete="current-password" value={current}
                     onChange={(e) => setCurrent(e.target.value)} />
            </label>
            <label className="cp-field">New password ({MIN} characters or more)
              <input type="password" autoComplete="new-password" value={next}
                     onChange={(e) => setNext(e.target.value)} />
            </label>
            <label className="cp-field">New password again
              <input type="password" autoComplete="new-password" value={again}
                     onChange={(e) => setAgain(e.target.value)} />
            </label>
            {error && <p className="cp-err">{error}</p>}
            <div className="cp-foot">
              <span className="cp-why">{(current || next || again) ? why : ''}</span>
              <button type="button" className="btn" onClick={onClose} disabled={busy}>Cancel</button>
              <button type="submit" className="btn primary" disabled={!!why || busy}>
                {busy ? 'Changing…' : 'Change password'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
